import React from "react";
import "./Our_Strength.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Our_Strength = () => {
  const data = [
    "A team of skilled artisans, carpenters, painters, and civil experts",
    "End-to-end project management: design, execution & finishing",
    "Ability to handle projects of all sizes – from 1/2/3/4/5BHK apartments to luxury bungalows, row houses, and offices",
    "Proven record of on-time delivery and uncompromised quality",
  ];

  return (
    <section className="Our_Strength">
      <div className="container">
        <Common_Title subText=" Our Strengths " />

        <div className="features_div">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-sm-12">
                  <div className="details_card">
                    <img
                      src="/assets/images/services/key_elements/checked.png"
                      className="point_img"
                    />

                    <div className="content_div">
                      <p className="descn">{item}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Strength;
